import OutLineMobileFour from '@assets/icons/outline-mobile-four.svg'
import { Icon } from './Icon'

export const OutLineMobileFourIcon = Icon(OutLineMobileFour)
